import { render, staticRenderFns } from "./BaseRichText.vue?vue&type=template&id=172a1194&scoped=true&"
import script from "./BaseRichText.vue?vue&type=script&lang=js&"
export * from "./BaseRichText.vue?vue&type=script&lang=js&"
import style0 from "./BaseRichText.vue?vue&type=style&index=0&id=172a1194&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a1194",
  null
  
)

export default component.exports